'use client'

import { useAuthSync } from '@/lib/use-auth-async'
import TrialBanner from '@/utils/trialBanner'
export default function AuthSyncWrapper({
  children
}: {
  children: React.ReactNode
}) {
  useAuthSync()
  return <>
  <TrialBanner/>
    {children}</>
}
